export default "__VITE_PUBLIC_ASSET__c499377f__"